import ModuleConfig from './Config';

const actions = ModuleConfig.Actions;

const initialState = {
    schedules: [],
    shops: [],
    employees: [],
    currentSchedule: null,
    weeklyStats: [],
    coverageReport: null,
    vacationRequests: [],
    pendingVacations: [],
    changeRequests: [],
    pendingChangeRequests: [],
    loading: false,
    error: null
}

export default function scheduleProgram(state = initialState, action) {
    switch (action.type) {
        // Loading states
        case actions.getSchedules.request.id:
        case actions.getWeeklyStats.request.id:
        case actions.getCoverageReport.request.id:
            return { ...state, loading: true, error: null };

        // Schedules
        case actions.getSchedules.success.id:
            return { ...state, schedules: action.options.data, loading: false };

        case actions.getSchedule.success.id:
            return { ...state, currentSchedule: action.options };

        case actions.createSchedule.success.id:
            return {
                ...state,
                schedules: [...state.schedules, action.options],
                loading: false
            };

        case actions.updateSchedule.success.id:
            return {
                ...state,
                schedules: state.schedules.map(s =>
                    s.id === action.options.id ? action.options : s
                ),
                loading: false
            };

        case actions.deleteSchedule.success.id:
            return {
                ...state,
                schedules: state.schedules.filter(s => s.id !== action.options.id),
                loading: false
            };

        case actions.bulkCreateSchedules.success.id:
            return {
                ...state,
                schedules: [...state.schedules, ...action.options.data],
                loading: false
            };

        // Shops and employees
        case actions.getShops.success.id:
            return { ...state, shops: action.options };

        case actions.getEmployees.success.id:
            return { ...state, employees: action.options };

        // Weekly stats
        case actions.getWeeklyStats.success.id:
            return { ...state, weeklyStats: action.options, loading: false };

        // Coverage report
        case actions.getCoverageReport.success.id:
            return { ...state, coverageReport: action.options, loading: false };

        // Vacation requests
        case actions.getVacationRequests.success.id:
            return { ...state, vacationRequests: action.options, pendingVacations: action.options.filter(v => v.status === 'pending') };

        case actions.createVacationRequest.success.id:
            return {
                ...state,
                vacationRequests: [...state.vacationRequests, action.options]
            };

        case actions.approveVacationRequest.success.id:
        case actions.rejectVacationRequest.success.id:
        case actions.cancelVacationRequest.success.id:
            return {
                ...state,
                vacationRequests: state.vacationRequests.map(v =>
                    v.id === action.options.id ? action.options : v
                ),
                pendingVacations: state.pendingVacations.filter(v => v.id !== action.options.id)
            };

        // Change requests
        case actions.getChangeRequests.success.id:
            return {
                ...state,
                changeRequests: action.options,
                pendingChangeRequests: action.options.filter(c =>
                    c.status === 'pending_admin' || c.status === 'pending_employee'
                )
            };

        case actions.createSwapRequest.success.id:
            return {
                ...state,
                changeRequests: [...state.changeRequests, action.options]
            };

        case actions.approveChangeRequest.success.id:
        case actions.rejectChangeRequest.success.id:
        case actions.overrideChangeRequest.success.id:
            return {
                ...state,
                changeRequests: state.changeRequests.map(c =>
                    c.id === action.options.id ? action.options : c
                ),
                pendingChangeRequests: state.pendingChangeRequests.filter(c => c.id !== action.options.id)
            };

        // Error handling
        case actions.getSchedules.failure.id:
        case actions.getWeeklyStats.failure.id:
        case actions.getCoverageReport.failure.id:
            return { ...state, loading: false, error: action.options };

        default:
            return state;
    }
}
